class PogiPdpVideoControls extends HTMLElement {
  #observer;
  #controller;
  #video;
  #button;

  connectedCallback() {
    // Android already provides a central native play button. Keep its player unobstructed.
    if (navigator.userAgentData?.platform === 'Android' || /Android/i.test(navigator.userAgent)) return;
    const media = this.closest('deferred-media');
    if (!media || !this.closest('media-gallery')) return;
    const bind = () => {
      const video = [...media.querySelectorAll(':scope > video')].at(-1);
      if (!video || video === this.#video) return;
      this.#controller?.abort();
      this.#video = video;
      this.#button = this.querySelector('button');
      if (!this.#button || !getComputedStyle(this).getPropertyValue('--pogi-player-ready').trim()) return;
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      const sync = () => {
        this.#button.hidden = !video.paused && !video.ended;
      };
      for (const event of ['play', 'playing', 'pause', 'ended', 'error']) {
        video.addEventListener(event, sync, { signal });
      }
      this.#button.addEventListener('mousedown', event => event.stopPropagation(), { signal });
      this.#button.addEventListener('click', event => {
        event.stopPropagation();
        if (document.hidden || this.closest('slideshow-slide')?.getAttribute('aria-hidden') === 'true') return;
        if (video.ended) video.currentTime = 0;
        media.dispatchEvent(new Event('media:started-playing', { bubbles: true }));
        video.play().then(() => {
          if (document.activeElement === this.#button) video.focus({ preventScroll: true });
        }).catch(sync);
      }, { signal });
      this.hidden = false;
      this.style.removeProperty('display');
      sync();
    };
    this.#observer = new MutationObserver(bind);
    this.#observer.observe(media, { childList: true });
    bind();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#controller?.abort();
    this.#video = null;
    this.hidden = true;
    this.style.display = 'none';
  }
}

if (!customElements.get('pogi-pdp-video-controls')) {
  customElements.define('pogi-pdp-video-controls', PogiPdpVideoControls);
}
